module.exports = [{
  plugin: require('/tmp/28f17b1b/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
  options: {
    "plugins": [],
    "remarkPlugins": [null, null]
  }
}, {
  plugin: require('/tmp/28f17b1b/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}, {
  plugin: require('/tmp/28f17b1b/node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}, {
  plugin: require('/tmp/28f17b1b/node_modules/gatsby-theme-mdx-deck/gatsby-browser.js'),
  options: {
    "plugins": [],
    "cli": true,
    "contentPath": "/tmp/28f17b1b/deck.mdx"
  }
}];